import React from 'react';

interface Partner {
    name: string;
    logo: string;
    type: string;
    link?: string;
}

interface PartnerGridProps {
    partners: Partner[];
    className?: string;
}

export const PartnerGrid: React.FC<PartnerGridProps> = ({
    partners,
    className = '',
}) => {
    return (
        <div className={`ecosystem-partners ${className}`}>
            {partners.map((partner, index) => (
                <a
                    key={index}
                    href={partner.link || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ecosystem-partner"
                >
                    <img
                        src={partner.logo}
                        alt={partner.name}
                        className="ecosystem-partner-logo"
                    />
                    <span className="ecosystem-partner-name">{partner.name}</span>
                    <span className="ecosystem-partner-type">{partner.type}</span>
                </a>
            ))}
        </div>
    );
};

export default PartnerGrid;
